import React from 'react'
import styled from 'styled-components'
import { device } from '../Breakpoints'
import { colors } from '../Colors'

class PageEye extends React.Component {
  constructor(props) {
    super()
    this.state = {
      ...props,
    }
  }

  render() {
    const {
      title,
      content2,
      content,
      image,
      color,
      height = '200px',
      imgWidth = '45%',
      imgWidthMobile = '138%',
      imgMarginMobile = '1em -2.2em -2em',
      bottom = '-1px',
      right = '0px',
      titleWidth = '650px',
      overflow = 'hidden',
    } = this.state

    const handleBgColor = () => {
      switch (color) {
        case 'azul':
          return colors.azulGradiente
        case 'verde':
          return colors.verdeGradiente
        case 'laranja':
          return colors.laranjaGradiente
        case 'laranjaReverso':
          return colors.laranjaGradienteReverso
        case 'lilas':
          return colors.lilasGradiente
        default:
          return colors.branco
      }
    }
    const handleBorderColor = () => {
      switch (color) {
        case 'lilas-vermelho':
          return colors.lilas
        case 'vermelho':
          return colors.vermelho
        case 'branco-lilas':
          return colors.lilas
        case 'lilas-cinza':
          return colors.lilas
        case 'branco-verde':
          return colors.verde
        default:
          return colors.branco
      }
    }
    const handleContentColor = () => {
      switch (color) {
        case 'lilas-vermelho':
          return colors.cinza
        case 'vermelho':
          return colors.cinza
        case 'branco-lilas':
          return colors.lilas
        case 'lilas-cinza':
          return colors.cinza
        case 'branco-verde':
          return colors.cinza
        default:
          return colors.branco
      }
    }
    const handleTitleColor = () => {
      switch (color) {
        case 'lilas-vermelho':
          return colors.vermelho
        case 'vermelho':
          return colors.vermelho
        case 'branco-lilas':
          return colors.lilas
        case 'lilas-cinza':
          return colors.lilas
        case 'branco-verde':
          return colors.cinza
        case 'laranjaReverso':
          return colors.amarelo
        default:
          return colors.branco
      }
    }
    const Header = styled.section`
      padding: 3em 2em;
      position: relative;
      background: ${props => handleBgColor(props.color)}!important;
      overflow: ${() => {
        return overflow
      }};
      h2 {
        font-weight: normal;
      }
      @media ${device.mobileL} {
        padding: 2em !important;
        margin-top: 0;
      }
      .image {
        position: absolute;
        display: block;
        right: ${() => {
          return right
        }};
        bottom: ${() => {
          return bottom
        }};
        width: ${() => {
          return imgWidth
        }};
        z-index: 3;
        @media ${device.mobileL} {
          right: 0px;
          bottom: inherit;
          width: 272px;
          top: -162px;
          position: static;
        }
      }
      div {
        @media ${device.tablet} {
          width: 50%;
          font-weight: normal;
          font-size: 1em;
          margin-left: 5%;
        }
        @media ${device.mobileL} {
          width: 100%;
          font-weight: normal;
          font-size: 1em;
          margin-left: 0;
          box-sizing: border-box;
        }
      }

      .inner {
        border-bottom: 6px ${props => handleBorderColor(props.color)} solid;
        border-left: 6px ${props => handleBorderColor(props.color)} solid;
        border-right: 6px ${props => handleBorderColor(props.color)} solid;
        padding: 1em 2em;
        margin: 0;
        position: relative;
        min-height: ${() => {
          return height
        }};
        align-items: center;
        @media ${device.mobileL} {
          display: block;
          padding: 2em;
        }
        img {
          height: auto;
          width: ${() => {
            return imgWidth
          }};
          @media ${device.mobileL} {
            width: ${() => {
              return imgWidthMobile
            }};
            margin: ${() => {
              return imgMarginMobile
            }};
          }
        }
        :before {
          content: '';
          background: ${props => handleBorderColor(props.color)};
          width: 2%;
          height: 6px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          @media ${device.mobileL} {
            width: 8%;
          }
        }
        .content {
          font-size: 0.8em;
          width: 56%;
          line-height: 1.6em;
          color: ${props => handleContentColor(props.color)};
          @media ${device.mobileL} {
            width: 100%;
            font-size: 1.5em;
            text-align: left;
          }
          a {
            color: ${props => handleContentColor(props.color)};
          }
          ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 0 1em;
            li {
              width: 33%;
              margin-bottom: 0;
              font-size: 0.9em;
              @media ${device.mobileL} {
                width: 100%;
              }
            }
          }
        }
        .content2 {
          font-size: 0.8em;
          width: 100%;
          line-height: 1.6em;
          margin-bottom: 50px;
          color: ${props => handleContentColor(props.color)};
          @media ${device.mobileL} {
            width: 100%;
            font-size: 1.5em;
            text-align: left;
          }
          p {
            min-width: 100%;
          }
          a {
            color: ${props => handleContentColor(props.color)};
          }
          ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 0 1em;
            li {
              width: 33%;
              margin-bottom: 0;
              @media ${device.mobileL} {
                width: 100%;
              }
            }
          }
        }
        h1 {
          font-family: 'Santral Bold', Arial, Helvetica, sans-serif;
          font-size: 48px;
          color: ${props => handleTitleColor(props.color)};
          line-height: 1em;
          margin-top: -52px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          div.title {
            max-width: ${() => {
              return titleWidth
            }};
          }
          :after {
            content: '';
            background: ${props => handleBorderColor(props.color)};
            height: 6px;
            flex-grow: 1;
            margin: 32px -40px 0px 10px;
            @media ${device.mobileL} {
              margin: 10px -40px 0px 10px;
            }
          }
          @media ${device.mobileL} {
            text-align: left;
            padding: 0;
            margin-top: -50px;
          }
        }
        p {
          font-size: 1em;
          width: 100%;
          max-width: 560px;
          line-height: 1.6em;
          @media ${device.mobileL} {
            width: 100%;
            text-align: left;
          }
        }
        @media ${device.mobileL} {
          margin: 0;
          h2 {
            position: initial;
            text-align: left;
            padding: 0;
          }
        }
      }
    `
    const AlignCenter = styled.div`
      max-width: 1180px;
      margin: 0 auto 0;
      @media ${device.mobileL} {
        max-width: 100%;
        text-align: center;
      }
    `

    return (
      <Header className={color}>
        <AlignCenter>
          <div className="inner">
            <h1>
              <div className="title">{title}</div>
            </h1>
            {content2 ? (
              <div
                className="content2"
                dangerouslySetInnerHTML={{ __html: content2 }}
              />
            ) : (
              ''
            )}

            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <img src={image} alt={title} className="image" />
          </div>
        </AlignCenter>
      </Header>
    )
  }
}

export default PageEye
